import React from 'react';
import { History } from 'lucide-react';
import {
  formatReincidenciaDataAbertura,
  getReincidenciaStepOsLabel,
} from '../utils/orderDetailsReincidenciaUtils';

const STEP_LINE_ACTIVE = '#0f172a';
const STEP_LINE_PAST = '#e2e8f0';

function ReincidenciaStepDot({ isCurrent }) {
  if (isCurrent) {
    return (
      <span
        className="order-details-v2-reincidencia-dot order-details-v2-reincidencia-dot--current"
        aria-hidden
      />
    );
  }
  return <span className="order-details-v2-reincidencia-dot order-details-v2-reincidencia-dot--past" aria-hidden />;
}

export function OrderDetailsReincidenciaPanel({ orderId, items, loading, error }) {
  const currentId = String(orderId ?? '').trim();

  return (
    <aside
      id="order-details-v2-reincidencia-panel"
      className="order-details-v2-col order-details-v2-col--reincidencia"
      aria-label="Histórico de reincidência"
    >
      <div className="order-details-v2-reincidencia-panel">
        <div className="order-details-v2-reincidencia-head order-details-v2-block-head">
          <h3 className="order-details-v2-block-title">
            <History size={20} strokeWidth={2} aria-hidden />
            Histórico de reincidência
          </h3>
        </div>
        <div className="order-details-v2-reincidencia-body">
          {loading ? (
            <p className="order-details-v2-reincidencia-hint">Carregando…</p>
          ) : error ? (
            <p className="order-details-v2-reincidencia-error">{error}</p>
          ) : items.length === 0 ? (
            <p className="order-details-v2-reincidencia-hint">Sem registros.</p>
          ) : (
            <ol className="order-details-v2-reincidencia-timeline" aria-label="Linha do tempo de reincidência">
              {items.map((item, index) => {
                const osAtual = String(item.OS_Atual ?? '').trim();
                const isCurrent = Boolean(currentId && osAtual === currentId);
                const osLabel = getReincidenciaStepOsLabel(item, currentId);
                const isLast = index === items.length - 1;
                const lineTone = isCurrent ? STEP_LINE_ACTIVE : STEP_LINE_PAST;

                return (
                  <li
                    key={`${item.OS_Atual}-${item.Indice}-${index}`}
                    className={`order-details-v2-reincidencia-step${isCurrent ? ' order-details-v2-reincidencia-step--current' : ''}`}
                  >
                    <div className="order-details-v2-reincidencia-rail" aria-hidden>
                      <ReincidenciaStepDot isCurrent={isCurrent} />
                      {!isLast ? (
                        <span
                          className="order-details-v2-reincidencia-line"
                          style={{ backgroundColor: lineTone }}
                        />
                      ) : null}
                    </div>
                    <div className="order-details-v2-reincidencia-content">
                      {isCurrent ? (
                        <div className="order-details-v2-reincidencia-current-box">
                          <span className="order-details-v2-reincidencia-os">
                            OS {osLabel}
                            <span className="order-details-v2-reincidencia-atual"> (Atual)</span>
                          </span>
                          <span className="order-details-v2-reincidencia-date">
                            {formatReincidenciaDataAbertura(item.TB02115_DATA)}
                          </span>
                        </div>
                      ) : (
                        <>
                          <span className="order-details-v2-reincidencia-os">OS {osLabel}</span>
                          <span className="order-details-v2-reincidencia-date">
                            {formatReincidenciaDataAbertura(item.TB02115_DATA)}
                          </span>
                        </>
                      )}
                    </div>
                  </li>
                );
              })}
            </ol>
          )}
        </div>
      </div>
    </aside>
  );
}
